import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { userSelector } from '../../features/user/userSlice';

import moment from 'moment';

import { useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SvgIcon from '@mui/material/SvgIcon';

function MaintenanceTask(props) {
  const { t } = useTranslation('maintenance');

  const { user } = useSelector(userSelector);

  const navigate = useNavigate();

  const theme = useTheme();

  const { maintenanceTask } = props;

  const handleClick = () => {
    if (user?.username && user?.username !== 'reader') {
      navigate('details', {
        state: { maintenanceTaskId: maintenanceTask?.id },
      });
    }
  };

  const calculateStep = () => {
    if (maintenanceTask?.status === 'waiting_for_start') return 0;
    if (maintenanceTask?.status === 'waiting_for_finish') return 1;
    if (maintenanceTask?.status === 'waiting_for_acknowledgement') return 2;
    if (maintenanceTask?.status === 'rejected') return 3;
    if (maintenanceTask?.status === 'accepted') return 4;
  };

  const step = calculateStep();

  return (
    <Paper
      sx={{
        p: 1,
        // minWidth: 275,
        width: { xs: '100%', sm: '240px' },
        // minWidth: '240px',
        // maxWidth: '600px',
        // flexGrow: 1,
        // flexShrink: 0,
        // flexBasis: 1,
        background: `linear-gradient(${
          maintenanceTask?.priority?.backgroundColor
        }, ${
          theme.palette.mode === 'light'
            ? '#FFFFFF'
            : 'rgba(255, 255, 255, 0.05)'
        } 20%)`,
        // background: (theme) =>
        //   `linear-gradient(${maintenanceTask?.priority?.backgroundColor}, ${
        //     theme.palette.mode === 'light'
        //       ? '#FFFFFF'
        //       : 'rgba(255, 255, 255, 0.05)'
        //   } 20%)`,
        // background: (theme) => `0 0 4px ${theme.colors.primary}`,
        // border: '1px solid #000000',
      }}
      onClick={handleClick}
    >
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            sx={{ fontSize: 12, flexBasis: '26px' }}
            color="text.secondary"
          >
            {maintenanceTask?.id}
          </Typography>
          <Box sx={{ flexBasis: '100%' }}>
            <Typography>{maintenanceTask?.area?.areaName}</Typography>
            <Typography>{maintenanceTask?.line?.lineName}</Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary">
              {maintenanceTask?.equipment?.equipmentName}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            ml: '10%',
            mr: '10%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
          }}
        >
          <SvgIcon>
            {step > 0 ? (
              <path
                d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
                fill={
                  step === 1
                    ? theme.palette.warning.main
                    : step === 2
                    ? theme.palette.success.main
                    : step === 3
                    ? theme.palette.warning.main
                    : theme.palette.primary.main
                }
              />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                  fill={
                    step >= 0
                      ? theme.palette.error.main
                      : theme.palette.text.disabled
                  }
                />
                <text
                  x="12"
                  y="12"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill={theme.palette.primary.contrastText}
                  fontSize={theme.typography.caption.fontSize}
                  fontFamily={theme.typography.fontFamily}
                >
                  1
                </text>
              </svg>
            )}
          </SvgIcon>
          <Box
            sx={(theme) => ({
              mx: '6px',
              width: '30%',
              height: '1px',
              backgroundColor:
                theme.palette.mode === 'light'
                  ? theme.palette.grey[400]
                  : theme.palette.grey[600],
            })}
          />
          <SvgIcon>
            {step > 1 && step !== 3 ? (
              <path
                d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
                fill={
                  step === 1
                    ? theme.palette.warning.main
                    : step === 2
                    ? theme.palette.success.main
                    : theme.palette.primary.main
                }
              />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                  fill={
                    step >= 1
                      ? theme.palette.warning.main
                      : theme.palette.text.disabled
                  }
                />
                <text
                  x="12"
                  y="12"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill={theme.palette.primary.contrastText}
                  fontSize={theme.typography.caption.fontSize}
                  fontFamily={theme.typography.fontFamily}
                >
                  2
                </text>
              </svg>
            )}
          </SvgIcon>
          <Box
            sx={{
              mx: '6px',
              width: '30%',
              height: '1px',
              backgroundColor:
                theme.palette.mode === 'light'
                  ? theme.palette.grey[400]
                  : theme.palette.grey[600],
            }}
          />
          <SvgIcon>
            {step > 2 && step !== 3 ? (
              <path
                d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
                fill={
                  step === 1
                    ? theme.palette.warning.main
                    : step === 2
                    ? theme.palette.success.main
                    : theme.palette.primary.main
                }
              />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                  fill={
                    step >= 2
                      ? step === 3
                        ? theme.palette.error.main
                        : theme.palette.success.main
                      : theme.palette.text.disabled
                  }
                />
                <text
                  x="12"
                  y="12"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill={theme.palette.primary.contrastText}
                  fontSize={theme.typography.caption.fontSize}
                  fontFamily={theme.typography.fontFamily}
                >
                  3
                </text>
              </svg>
            )}
          </SvgIcon>
        </Box>
        <Box sx={{ mt: 1 }}>
          <b>{t(maintenanceTask?.status)}</b>
          {maintenanceTask?.status === 'waiting_for_start' ? (
            <Box>
              <Typography variant="body2">
                {maintenanceTask?.createdByUser?.username}
              </Typography>
              <Typography variant="body2">
                {maintenanceTask?.createdAt
                  ? moment(maintenanceTask?.createdAt).format('L LTS')
                  : null}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  lineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                }}
              >
                {maintenanceTask?.createdComment}
              </Typography>
            </Box>
          ) : null}
          {maintenanceTask?.status === 'waiting_for_finish' ? (
            <Box>
              <Typography variant="body2">
                {maintenanceTask?.startedByUser?.username}
              </Typography>
              <Typography variant="body2">
                {maintenanceTask?.startedAt
                  ? moment(maintenanceTask?.startedAt).format('L LTS')
                  : null}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  lineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                }}
              >
                {maintenanceTask?.startedComment}
              </Typography>
            </Box>
          ) : null}
          {maintenanceTask?.status === 'waiting_for_acknowledgement' ? (
            <Box>
              <Typography variant="body2">
                {maintenanceTask?.finishedByUser?.username}
              </Typography>
              <Typography variant="body2">
                {maintenanceTask?.finishedAt
                  ? moment(maintenanceTask?.finishedAt).format('L LTS')
                  : null}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  lineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                }}
              >
                {maintenanceTask?.finishedComment}
              </Typography>
            </Box>
          ) : null}
          {maintenanceTask?.status === 'accepted' ? (
            <Box>
              <Typography variant="body2">
                {maintenanceTask?.acknowledgedByUser?.username}
              </Typography>
              <Typography variant="body2">
                {maintenanceTask?.acknowledgedAt
                  ? moment(maintenanceTask?.acknowledgedAt).format('L LTS')
                  : null}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  lineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                }}
              >
                {maintenanceTask?.acknowledgedComment}
              </Typography>
            </Box>
          ) : null}
          {maintenanceTask?.status === 'rejected' ? (
            <Box>
              <Typography variant="body2">
                {maintenanceTask?.acknowledgedByUser?.username}
              </Typography>
              <Typography variant="body2">
                {maintenanceTask?.acknowledgedAt
                  ? moment(maintenanceTask?.acknowledgedAt).format('L LTS')
                  : null}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  lineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                }}
              >
                {maintenanceTask?.acknowledgedComment}
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Paper>
  );
}

export default MaintenanceTask;
